import UndoIcon from '@mui/icons-material/Undo';
import { Alert, Box, Button, Typography } from '@mui/material';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { decode } from 'js-base64';
import React from 'react';
import { handleCancelOrderDraft } from '../utils';

const EmptyDraftConfirm = ({ ticket, handleShowComponent }) => {
  const handleConfirm = async () => {
    await handleCancelOrderDraft({ ticket });
    handleShowComponent('cancelOrder', true);
  };

  const dangerousHTML = decode(ticket?.draft?.htmlBody);

  return (
    <Box
      sx={{
        // height: '40rem',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
      }}
    >
      <Box
        sx={{
          width: '80%',
          height: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          margin: '1em 0',
        }}
      >
        <Alert severity="info" variant="outlined" icon={false}>
          Attention, en continuant, vous effacerez le brouillon ci-dessous.
          Souhaitez-vous continuez?
        </Alert>
      </Box>
      <Box
        sx={{
          // width: "80%",
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            border: '1px solid #e0e0e0',
            borderBottom: 'none',
            backgroundColor: 'rgba(245, 245, 245, 0.5)',
            borderRadius: '4px 4px 0 0 ',
            padding: '0 2em',
            width: '80%',
            overflow: 'auto',
            display: 'block',
          }}
        >
          <Typography variant="span" sx={{ fontSize: '0.9em' }}>
            De : {ticket?.draft?.from}, modifié le{' '}
            {format(new Date(ticket?.draft?.updatedAt), 'dd/MM/yyyy à HH:mm', {
              locale: fr,
            })}
          </Typography>
        </Box>
        <Box
          sx={{
            border: '1px solid #e0e0e0',
            backgroundColor: 'rgba(245, 245, 245, 0.5)',
            borderRadius: '0 0 4px 4px',
            padding: '0 2em',
            width: '80%',
            height: '45vh',
            overflow: 'auto',
            display: 'block',
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: dangerousHTML }} />
        </Box>
      </Box>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Button
            color="primary"
            onClick={() => handleShowComponent(null)}
            variant="contained"
            startIcon={<UndoIcon />}
          >
            Retour
          </Button>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: 'auto',
            margin: '1em 1em',
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{ fontWeight: 'bold' }}
            onClick={handleConfirm}
          >
            Continuer
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default EmptyDraftConfirm;
